var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCbacLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.04 43.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.6,14.1c-.1-10.1-10.4-8.6-12-8.3-.1,0-.2.1-.2.3l2.2,6.6c.1.3.4.5.7.4,5.2-1.3,8.4.6,9.1,1.1.1,0,.2,0,.2-.1",
    fill: "#c6c6c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9,14.1c.1-10.1,10.4-8.6,12-8.3.1,0,.2.1.1.4l-2.2,6.8c0,.1-.2.2-.5.2-5.2-1.5-8.5.5-9.3,1,0,0-.1,0-.1-.1",
    fill: "#e95a0c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m28.9,8.3c2.4-6.3,9.1-6,10.5-5.9.1,0,.2.1.2.3l-.7,2.1-.1.1c-6-.7-8.7,2.1-9.7,3.6-.1,0-.3,0-.2-.2",
    fill: "#71b7e5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m38.8.2l-.4,1.3-.1.1c-4.8,0-7.4,2.6-8.4,4-.1.1-.2,0-.2-.1.9-1.9,3.4-5.5,8.9-5.5.2,0,.3.1.2.2",
    fill: "#fcc443"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m4.3,25.6c-2.8,0-4.3-2.3-4.3-4.6s1.5-4.6,4.3-4.6c2.2,0,3.4,1.3,3.4,1.4.3.3.2.7,0,1-.3.3-.7.2-1,0,0,0-.9-.9-2.4-.9-2,0-2.9,1.6-2.9,3.1s.9,3.2,2.9,3.2c1.5,0,2.4-.9,2.4-.9.3-.3.7-.3,1-.1.3.3.3.7.1,1-.1.1-1.3,1.4-3.5,1.4",
    fill: "#009ee2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m33,40c-2.8,0-4.3-2.3-4.3-4.6s1.5-4.6,4.3-4.6c2.2,0,3.4,1.3,3.4,1.4.3.3.2.7,0,1-.3.3-.7.2-1,0,0,0-.9-.9-2.4-.9-2,0-2.9,1.6-2.9,3.1s.9,3.2,2.9,3.2c1.5,0,2.4-.9,2.4-.9.3-.3.7-.3,1-.1.3.3.3.7.1,1-.1.1-1.4,1.4-3.5,1.4",
    fill: "#009ee2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m14.1,43.4c-.2,0-.5-.1-.6-.3-.2-.3-.1-.8.2-1,1.2-.9,1.3-2.5,1.3-3.1h0v-7.4c0-.4.3-.7.7-.7s.7.3.7.7v7.4c0,.9-.1,3.1-2,4.4h-.3",
    fill: "#009ee2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m33,25.5c-2.8,0-4.3-2.3-4.3-4.6s1.5-4.6,4.3-4.6c2.2,0,3.4,1.3,3.4,1.4.3.3.2.7,0,1-.3.3-.7.2-1,0,0,0-.9-.9-2.4-.9-2,0-2.9,1.6-2.9,3.1s.9,3.2,2.9,3.2c1.5,0,2.3-.9,2.4-.9.3-.3.7-.3,1-.1.3.3.3.7.1,1-.1.1-1.3,1.4-3.5,1.4",
    fill: "#009ee2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m11.5,30.9c-.4,0-.7.3-.7.7v5.2c0,1-.8,1.8-1.8,1.8h-.1c-1,0-1.8-.8-1.8-1.8v-5.2c0-.4-.3-.7-.7-.7s-.7.3-.7.7v5.2c0,1-.8,1.8-1.8,1.8h-.1c-1,0-1.8-.8-1.8-1.8v-5.2c0-.4-.3-.7-.7-.7s-.7.3-.7.7v5.2c0,1.8,1.5,3.3,3.3,3.3h.1c1,0,1.9-.5,2.5-1.2.6.7,1.5,1.2,2.5,1.2h0c1.8,0,3.3-1.5,3.3-3.3v-5.2c-.1-.4-.4-.7-.8-.7",
    fill: "#009ee2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m13.3,24.2c-.9,0-1.5-.3-1.8-.6-.2-.2-.3-.4-.3-.7v-3c0-.7.5-2,2.2-2,2.3,0,2.9,2.1,2.9,3.1-.1,1.5-1,3.2-3,3.2m0-7.8c-.9,0-1.6.3-2.2.7v-3.3c0-.4-.3-.7-.7-.7s-.7.3-.7.7v9.7c0,.1,0,.2.1.3,0,.1,1,1.8,3.5,1.8,1.3,0,2.4-.5,3.2-1.5.7-.8,1.1-2,1.1-3.1s-.4-2.1-1-3c-.5-.7-1.5-1.6-3.3-1.6",
    fill: "#009ee2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m20.2,34.7c.3-2.3,2.3-2.4,2.7-2.4,1.8,0,2.4,1.5,2.5,2.4h-5.2Zm2.7-3.8c-1.8,0-2.8.9-3.3,1.6-.8,1.1-.9,2.3-.9,3,0,1.2.4,2.3,1.1,3.1.8,1,1.9,1.5,3.2,1.5,2.2,0,3.4-1.4,3.4-1.4.3-.3.2-.7-.1-1-.3-.3-.7-.2-1,.1,0,0-.9.9-2.4.9-1.7,0-2.6-1.2-2.8-2.4h6c.4,0,.7-.3.7-.7.1-2.4-1.1-4.7-3.9-4.7",
    fill: "#009ee2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m25.5,22.2c0,.7-.5,2-2.2,2-2.3,0-2.9-2.1-2.9-3.1,0-1.5.9-3.2,2.9-3.2.9,0,1.5.3,1.8.6.2.2.3.4.3.7v3h.1Zm1.4-4c0-.1-1-1.8-3.5-1.8-2.8,0-4.3,2.3-4.3,4.6,0,1.2.4,2.3,1.1,3.1.8,1,1.9,1.5,3.2,1.5h0c.9,0,1.6-.3,2.1-.7,0,.4.3.7.7.7s.7-.3.7-.7v-6.4c.1-.1,0-.2,0-.3",
    fill: "#009ee2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbacLogo);
export default __webpack_public_path__ + "static/media/cbacLogo.06487e18ad232efbee8052c5a67f8e22.svg";
export { ForwardRef as ReactComponent };